import { Filter, NumberFilter, RangeFilter, SelectFilter } from '@increasecard/typed-components';
import { Field, SelectOption } from '@increasecard/typed-components/dist/types/Field';
import { Shop } from '@card/types';
import { TFunction } from 'i18next';
import { compare } from './stringUtils';
import { processorNameToInfoProviders } from '@card/commonlib';

export function shopsToOptions(shops: Shop[]): SelectOption[] {
  return shops.map(({ name, id }) => ({ name, value: id }));
}

export function infoProvidersToOptions(
  infoProviders: string[],
  translationFunction: TFunction
): SelectOption[] {
  // I used a set to avoid repeated elements
  const infoProvidersSet = new Set(infoProviders);
  return Array.from(infoProvidersSet).map((infoProvider) => {
    return {
      name: translationFunction(`common:processorNames:${infoProvider}`),
      value: infoProvider
    };
  });
}

export function filtersToParams(filters: Record<string, Filter>) {
  let filtersToReturn: Record<string, string | string[]> = {};
  Object.keys(filters).forEach((filterKey) => {
    switch (filterKey) {
      case 'daterange': {
        const value = (filters[filterKey] as RangeFilter<string, Field>).value;
        filtersToReturn = {
          ...filtersToReturn,
          [filterKey]: `${value.from} - ${value.to}`
        };
        break;
      }
      case 'info_provider': {
        const value = processorNameToInfoProviders((filters[filterKey] as SelectFilter).value);
        filtersToReturn = {
          ...filtersToReturn,
          [filterKey]: value
        };
        break;
      }
      case 'amount': {
        const kind = (filters[filterKey] as NumberFilter).kind;
        let value: { from: string; to: string };
        switch (kind) {
          case 'between': {
            value = {
              from: (filters[filterKey] as RangeFilter<string, Field>).value.from,
              to: (filters[filterKey] as RangeFilter<string, Field>).value.to
            };
            break;
          }
          case 'equals': {
            value = {
              from: filters[filterKey].value.toString(),
              to: filters[filterKey].value.toString()
            };
            break;
          }
          case 'greaterThan': {
            value = {
              from: filters[filterKey].value.toString(),
              to: ''
            };
            break;
          }
          case 'lowerThan': {
            value = {
              from: '',
              to: filters[filterKey].value.toString()
            };
            break;
          }
          default: {
            value = {
              from: '',
              to: filters[filterKey].value.toString()
            };
          }
        }
        filtersToReturn = {
          ...filtersToReturn,
          // eslint-disable-next-line @typescript-eslint/camelcase
          amount_from: value.from,
          // eslint-disable-next-line @typescript-eslint/camelcase
          amount_to: value.to
        };
        break;
      }
      default: {
        filtersToReturn = {
          ...filtersToReturn,
          [filterKey]: filters[filterKey].value as string | string[]
        };
      }
    }
  });
  return filtersToReturn;
}

export function compareOptionsByName(o1: SelectOption, o2: SelectOption): number {
  return compare(o1.name, o2.name);
}
